<template>
  <el-form
    ref="statisticsListFilterFormRef"
    class="statistics-list-filter"
    inline
    label-position="top"
    :model="filterFormData"
  >
    <el-form-item
      label="Period"
      class="statistics-list-filter__item"
    >
      <el-select
        v-model="selectedPeriod"
        :loading="isDashboardStatisticsPeriodListLoading"
        @change="handleStatisticsListFilterPeriodSelect"
      >
        <el-option
          v-for="period in dashboardStatisticsPeriodList"
          :key="period.value"
          :label="period.label"
          :value="period.value"
          class="statistics-list-filter__dropdown-item"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="selectedPeriod === DateTimeRangeTypes.CUSTOM"
      label="Custom period"
      class="statistics-list-filter__datepicker"
    >
      <el-date-picker
        v-model="filterFormDateTimeRange"
        type="datetimerange"
        :value-format="DateTimeFormatTypes.DATE_TIME_FULL"
        range-separator="To"
        start-placeholder="Select from"
        end-placeholder="Select to"
        @clear="clearDateRange"
      />
    </el-form-item>
    <el-button
      :loading="isStatisticsListLoading"
      :icon="icons.Refresh"
      type="primary"
      @click="submitFilterAction"
    >
      Apply
    </el-button>
  </el-form>
</template>

<script src="./statistics-list-filter.ts"></script>
<style lang="scss" src="./statistics-list-filter.scss"></style>
